// extracted by mini-css-extract-plugin
export default {"dot":"n2-z","dotSelected":"o2-z","dots":"p2-z","dotsContainer":"q2-z","leftArrowBtn":"r2-z","rightArrowBtn":"s2-z","arrowLeft":"t2-z","arrowDisabled":"u2-z"};